export default "__VITE_ASSET__CaHMLFj9__"